import { handleSelectType2 } from "../constants/product.constant";
const AutocompleteItems = ["sku", "product", "invetory-history"];
const selectItems = ["sku", "product", "invetory-history"];
const dateItems = ["product", "invetory-history", "store-requisition"];

const lockProductsOption = (language: string) => [
  { id: true, name: language === "fa-IR" ? "بله" : "yes" },
  { id: false, name: language === "fa-IR" ? "خیر" : "No" },
];
const reserveItemsOption = (language: string) => [
  { id: true, name: language === "fa-IR" ? "بله" : "yes" },
  { id: false, name: language === "fa-IR" ? "خیر" : "No" },
];

const EntryAndExitItemsOption = (language: string) => [
  { id: 100, name: language === "fa-IR" ? "ورود" : "Entry" },
  { id: 200, name: language === "fa-IR" ? "خروج" : "Exit" },
];
export const FormItems = (
  activeSection: string,
  queriesString: any,
  ActiveAutoComplete: any,
  dataSource: any,
  handleSearch: any,
  manufacturesList: any,
  warehouserList: any,
  rangeDate: any,
  language: string,
  CreatorEmail: string,
  Description: string,
  EntryAndExit: number
) => {
  return [
    {
      activeSection: AutocompleteItems.includes(activeSection) ? true : false,
      componentType: "autoComplete",
      label: language === "fa-IR" ? "نام محصول" : "productName",
      name: "productName",
      defaultValue: queriesString.ProductName,
      dataSource: ActiveAutoComplete === "productName" ? dataSource : [],
      placeholder: language === "fa-IR" ? "نام محصول" : "productName",
      onSearch: (txt: string) => handleSearch(txt, "productName"),
    },
    {
      activeSection: activeSection === "store-requisition" ? true : false,
      componentType: "select",
      label: language === "fa-IR" ? "ورورد و خروج" : "EntryAndExit",
      name: "EntryAndExit",
      defaultValue: EntryAndExitItemsOption(language).find(
        (item: any) => item.id === Number(queriesString.EntryAndExit)
      )?.name,
      dataSource: EntryAndExitItemsOption(language),
      placeholder: language === "fa-IR" ? "ورورد و خروج" : "EntryAndExit",
    },

    {
      activeSection: AutocompleteItems.includes(activeSection) ? true : false,
      componentType: "autoComplete",
      label: language === "fa-IR" ? "شناسه کالا " : "SKU",
      name: "Sku",
      placeholder: language === "fa-IR" ? "شناسه کالا " : "SKU",
      defaultValue: queriesString.Sku,
    },
    {
      activeSection: selectItems.includes(activeSection) ? true : false,
      componentType: "select",
      label: language === "fa-IR" ? "تولید کننده" : "manufacturesList",
      name: "ManufacturerId",
      defaultValue: queriesString.ManufacturerId,
      dataSource: manufacturesList,
      placeholder: language === "fa-IR" ? "تولید کننده" : "manufacturesList",
    },
    {
      activeSection: activeSection === "store-requisition" ? true : false,
      componentType: "input",
      label: language === "fa-IR" ? "توضیحات " : "Description",
      name: "Description",
      defaultValue: queriesString.Description,
      dataSource: Description,
      placeholder: language === "fa-IR" ? "توضیحات " : "Description",
    },
    {
      activeSection: activeSection === "store-requisition" ? true : false,
      componentType: "input",
      label: language === "fa-IR" ? "ایمیل سازنده" : "CreatorEmail",
      name: "CreatorEmail",
      defaultValue: queriesString.CreatorEmail,
      dataSource: CreatorEmail,
      placeholder: language === "fa-IR" ? "ایمیل سازنده" : "CreatorEmail",
    },

    {
      activeSection: activeSection === "store-requisition" ? true : false,
      componentType: "select",
      label: language === "fa-IR" ? "انتخاب نوع" : "select to type",
      name: "Type",
      defaultValue: handleSelectType2.find(
        (item: any) => item.id === Number(queriesString.Type)
      )?.id,

      dataSource: handleSelectType2,
      placeholder: language === "fa-IR" ? "انتخاب نوع" : "select to type",
    },
    {
      activeSection: activeSection === "product" ? true : false,
      componentType: "select",
      label: language === "fa-IR" ? "انبار" : "warehouse",
      name: "WarehouseId",
      defaultValue: queriesString.WarehouseId,
      dataSource: warehouserList,
      placeholder: language === "fa-IR" ? "انبار" : "warehouse",
    },
    {
      activeSection: activeSection === "product" ? true : false,
      componentType: "select",
      label: language === "fa-IR" ? "تنها قفل شده ها" : "OnlyLockedProducts",
      name: "OnlyLockedProducts",
      defaultValue: queriesString.OnlyLockedProducts,
      dataSource: lockProductsOption("fa"),
      placeholder:
        language === "fa-IR" ? "تنها قفل شده ها" : "OnlyLockedProducts",
    },
    {
      activeSection: activeSection === "product" ? true : false,
      componentType: "select",
      label: language === "fa-IR" ? "تنها رزرو شده ها" : "OnlyReserevedItems",
      name: "OnlyReserevedItems",
      defaultValue: queriesString.OnlyReserevedItems,
      dataSource: reserveItemsOption("fa"),
      placeholder:
        language === "fa-IR" ? "تنها رزرو شده ها" : "OnlyReserevedItems",
    },
    {
      activeSection: activeSection === "product" ? true : false,
      componentType: "number",
      label: language === "fa-IR" ? "حداقل مجودی" : "MinimumQuantity",
      name: "MinimumQuantity",
      defaultValue: queriesString.MinimumQuantity,
      dataSource: reserveItemsOption(language),
      placeholder: language === "fa-IR" ? "حداقل مجودی" : "MinimumQuantity",
    },

    {
      activeSection: activeSection === "product" ? true : false,
      componentType: "number",
      label: language === "fa-IR" ? "حداکثر موجودی" : "MaximumQuantity",
      name: "MaximumQuantity",
      defaultValue: queriesString.MaximumQuantity,
      dataSource: reserveItemsOption(language),
      placeholder: language === "fa-IR" ? "حداکثر موجودی" : "MaximumQuantity",
    },

    {
      activeSection: dateItems.includes(activeSection) ? true : false,
      componentType: "date",
      label: language === "fa-IR" ? "بازه ی زمانی" : "rangeDate",
      name: "date",
      // defaultValue: rangeDate.split(","),
    },
  ];
};
